import {
  StoreModule,
  Store,
  ActionReducerMap,
  compose,
  combineReducers } from '@ngrx/store';
import { InjectionToken } from '@angular/core';

import * as loginReducer from './login.reducer';
import * as logoutReducer from './logout.reducer';
import * as bookingReducer from './booking.reducer';
import * as dataReducer from './data.reducer';
import * as registrationReducer from './registration.reducer';
import * as infoReducer from './info.reducer';
import * as headerReducer from './header.reducer';
import * as appointmentReducer from './appointment.reducer';

export class State {
  public booking: any;
  public login: any;
  public logout: any;
  public data: any;
  public registration: any;
  public info: any;
  public header: any;
  public appointment: any;
}
// collect all reducers
export const Reducers = {
  booking: bookingReducer.booking,
  login: loginReducer.login,
  logout: logoutReducer.logout,
  data: dataReducer.data,
  registration: registrationReducer.registration,
  info: infoReducer.info,
  header: headerReducer.header,
  appointment: appointmentReducer.appointment
};



// WEBPACK FOOTER //
// /Users/dtrubetskoi/Desktop/projects/online-booking-widget/src/app/reducers/index.ts